"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCommercialsImpression = exports.deleteCommercialsImpression = exports.getCommercialsImpressionCount = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getCommercialsImpressionCount(_a) {
    var where = _a.where;
    var variables = {
        where: where,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: CommercialsImpressionWhereInput) {\n        commercialsImpressionConnection(where: $where) {\n          _count {\n            commercialAdId\n          }\n        }\n      }\n    "], ["\n      query($where: CommercialsImpressionWhereInput) {\n        commercialsImpressionConnection(where: $where) {\n          _count {\n            commercialAdId\n          }\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getCommercialsImpressionCount = getCommercialsImpressionCount;
function deleteCommercialsImpression(_a) {
    var commercialAdId = _a.commercialAdId, userId = _a.userId, type = _a.type;
    var variables = {
        where: {
            commercialAdId_userId_type: {
                commercialAdId: commercialAdId,
                userId: userId,
                type: type,
            },
        },
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation($where: CommercialsImpressionWhereUniqueInput!) {\n        deleteCommercialsImpression(where: $where) {\n          commercialAdId\n        }\n      }\n    "], ["\n      mutation($where: CommercialsImpressionWhereUniqueInput!) {\n        deleteCommercialsImpression(where: $where) {\n          commercialAdId\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.deleteCommercialsImpression = deleteCommercialsImpression;
function createCommercialsImpression(_a) {
    var data = _a.data;
    var variables = {
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      mutation($data: CommercialsImpressionCreateCustomInput!) {\n        createCommercialsImpression(data: $data) {\n          commercialAdId\n        }\n      }\n    "], ["\n      mutation($data: CommercialsImpressionCreateCustomInput!) {\n        createCommercialsImpression(data: $data) {\n          commercialAdId\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.createCommercialsImpression = createCommercialsImpression;
var templateObject_1, templateObject_2, templateObject_3;
